<template>
  <div>
    <h2>References</h2>
    <div class="selection-details">
      If you used external resources to complete this entry, you may cite them here.
    </div>
    <div class="row top-section">
      <FormTable
          :rows="references"
          :columns="referenceColumns"
          :editing-index="entryBeingEdited"
          add-label="a reference"
          :show-form="showForm"
          @edit="editReference"
          @delete="removeReferenceFromTable"
          @toggle-form="toggleForm"
      />
    </div>
    <div v-if="showForm" class="row">
      <div class="col-12">
        <label for="inputReference" class="form-label">Reference Used</label>
        <input v-model="refName" type="text" class="form-control" id="inputReference">
      </div>
      <div class="col-12">
        <label for="inputReferenceAuthor" class="form-label">Author</label>
        <input v-model="refAuthor" type="text" class="form-control" id="inputReferenceAuthor">
      </div>
      <div class="col-12">
        <label for="inputReferenceLink" class="form-label">Link</label>
        <input v-model="refLink" type="url" class="form-control" id="inputReferenceLink">
      </div>
      <div class="col-12 save-reference-button">
        <button
            v-if="this.entryBeingEdited !== null"
            class="btn btn-secondary"
            @click="clearFormFields"
        >
          Cancel
        </button>
        <button class="btn btn-secondary" @click="addReferenceClicked">
          {{ referenceActionString }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {cleanupUrl, progressStatus} from '@/helpers/utils';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import FormTable from '@/components/add/FormTable.vue';
import {ROUTENAMES} from "@/helpers/constants";
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: "ReferenceForm",
  components: { FormTable },
  data() {
    return {
      showForm: false,
      references: [],
      referenceColumns: [
        { label: 'Reference', key: 'refName' },
        { label: 'Author', key: 'refAuthor' },
        { label: 'Link', key: 'refLink' },
      ],
      refName: null,
      refAuthor: null,
      refLink: null,
      entryBeingEdited: null,
    }
  },
  props: {
    triggerSaveDraft: { type: Boolean, default: false },
  },
  mounted() {
    const referenceData = this.getHomeFormSections.references?.data;
    if (referenceData && referenceData.length > 0) {
      this.references = cloneDeep(referenceData);
    } else {
      this.$emit('disableNext', 'Please add at least one reference.');
    }
  },
  beforeUnmount() {
    this.savePageContents();
  },
  watch: {
    triggerSaveDraft(to){
      if(to){
        this.savePageContents();
      }
    },
    wholeFormEmpty(to) {
      if (to) {
        this.$emit('disableNext', 'Please add at least one reference.');
        this.updateFormSection({ key: 'references', data: { status: null } });
      } else {
        this.$emit('disableNext', null);
        this.updateFormSection({ key: 'references', data: { status: progressStatus.DONE } });
      }
    }
  },
  computed: {
    ...mapGetters(['getHomeFormSections']),
    referenceActionString() {
      return this.entryBeingEdited !== null ? 'Update Reference' : 'Save Reference';
    },
    wholeFormEmpty() {
      return this.references.length < 1;
    }
  },
  methods: {
    ...mapActions(['updateFormSection']),
    savePageContents(){
      if(this.$route.name === ROUTENAMES.ADD_HOME) {
        this.updateFormSection({ key: 'references', data: { data: this.references } });
        if (this.wholeFormEmpty) {
          this.updateFormSection({ key: 'references', data: { status: null } });
        }
        this.$emit('disableNext', null);
      }
    },
    toggleForm() {
      this.showForm = !this.showForm
    },
    addReferenceClicked() {
      const newReference = { refName: this.refName, refAuthor: this.refAuthor, refLink: cleanupUrl(this.refLink) };
      if (this.entryBeingEdited === null) {
        this.references.push(newReference);
      } else {
        this.references[this.entryBeingEdited] = newReference;
      }
      this.clearFormFields();
    },
    clearFormFields() {
      this.refName = null;
      this.refAuthor = null;
      this.refLink = null;
      this.entryBeingEdited = null;
    },
    removeReferenceFromTable(index) {
      this.references.splice(index, 1);
      this.entryBeingEdited = null;
    },
    editReference(index) {
      this.showForm = true;
      this.entryBeingEdited = index;
      const entryToEdit = this.references[index];
      this.refName = entryToEdit.refName;
      this.refAuthor = entryToEdit.refAuthor;
      this.refLink = entryToEdit.refLink;
    },
  },
}
</script>

<style scoped>
.top-section {
  margin: 0 0 1rem 0;
}

.save-reference-button {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

</style>